import { DEFAULT_TEMPLATE } from "../constants";
export const getTempInfo = nodeData => {
  let status, startDate, endDate, own, participant;
  if (nodeData.e._sys_task_status && Object.keys(nodeData.e._sys_task_status).length) {
    const {
      index,
      prop
    } = nodeData.e._sys_task_status;
    status = index;
    startDate = prop ? prop[2] : null;
    endDate = prop ? prop[3] : null;
    own = prop ? prop[0] : null;
    participant = prop ? prop[1] : null;
  } else if (nodeData.e._sys_actions && nodeData.e._sys_actions.length) {
    const action = nodeData.e._sys_actions[0];
    status = action._startTime === null ? 0 : action._isCompleted ? 2 : 1;
    startDate = action._startTime;
    endDate = action._endTime;
    own = action._assigneeId.owner instanceof Array ? action._assigneeId.owner[0] : action._assigneeId.owner;
    participant = action._assigneeId.user; // kan
  } else {
    status = 0;
    startDate = nodeData.e._sys_createTime;
    endDate = null;
    own = null;
    participant = [];
  }
  const data = {
    // 模板id 默认ff(主题/任务/已完成)
    id: Array.isArray(nodeData.e._sys_temp) ? nodeData.e._sys_temp[0] : DEFAULT_TEMPLATE,
    // 模板属性
    prop: Array.isArray(nodeData.e._sys_temp) ? nodeData.e._sys_temp[1] || [] : [],
    // 模板状态(index) 主题0 任务1 已完成2
    status,
    // 模板状态属性
    statusProp: nodeData.e._sys_task_status ? nodeData.e._sys_task_status.prop || [] : [],
    sender: nodeData.e._sys_task_status?.sender || null,
    // 自定义属性
    customProp: Object.keys(nodeData.e).filter(x => !x.startsWith('_sys_')).reduce((res, prop) => {
      res[prop] = nodeData.e[prop];
      return res;
    }, {}),
    // 开始时间
    startDate,
    // 结束时间
    endDate,
    // 负责人
    own,
    // 参与者
    participant,
    //
    nodeSeq: nodeData.e?._sys_node_seq || 0
  };

  // hack ff 1 statusProp
  if (data.id === DEFAULT_TEMPLATE && data.status === 1) {
    data.statusProp = [own, participant, startDate, endDate];
  }
  return data;
};